import { DatePipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localePT from '@angular/common/locales/pt';
import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TitleStrategy, provideRouter } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import {
  AuthEffects,
  AuthModels,
  AuthReducers,
  CustomPageTitleStrategyService,
  HttpAuthInterceptor,
  PartnerConfigEffects,
  PartnerConfigModels,
  PartnerConfigReducers,
  ShellModels,
  ShellReducers,
  TitleModels,
  TitleReducers,
  UserEffects,
  UserModels,
  UserReducers,
} from '@white-label-front/shared/data-access';

import { appRoutes } from './app.routes';

registerLocaleData(localePT);

export const appConfig: ApplicationConfig = {
  providers: [
    provideEffects(
      AuthEffects.AuthEffects,
      UserEffects.UserEffects,
      PartnerConfigEffects.PartnerConfigEffects,
    ),
    provideStore({
      [AuthModels.AUTH_FEATURE_KEY]: AuthReducers.authReducer,
      [UserModels.USER_FEATURE_KEY]: UserReducers.userReducer,
      [PartnerConfigModels.PARTNER_CONFIG_FEATURE_KEY]:
        PartnerConfigReducers.partnerConfigReducer,
      [TitleModels.TITLE_FEATURE_KEY]: TitleReducers.titleReducer,
      [ShellModels.SHELL_FEATURE_KEY]: ShellReducers.shellReducer,
    }),
    provideRouter(appRoutes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([HttpAuthInterceptor])),
    DatePipe,
    { provide: TitleStrategy, useClass: CustomPageTitleStrategyService },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
  ],
};
